import styled from "styled-components"
import { up } from "styled-breakpoints"

export const NumberBadge = styled.div<{ number: number }>`
    position: absolute;
    top: 0px;
    right: -13px;

    display: ${ p => p.number === 0 ? 'none': 'grid' };
    align-items: center;
    justify-content: center;
    
    height: 25px;
    min-width: 25px;
    padding: 5px;

    border-radius: 13px;

    background: ${p => p.theme.colors.accent};

    color: white;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;

    ${up('tablet')} {
        right: -7px;

        height: 30px;
        min-width: 30px;

        border-radius: 15px;
    }
`